// extracted by mini-css-extract-plugin
export var smallSpinner = "_xa-0";